import React  from 'react';
import styled from 'styled-components';
import { TextBtn } from '../Inputs/TextBtn';
import { TextBtn2 } from '../Inputs/TextBtn2';
import { formatPrice } from '../Functions/Price';
const Styles = styled.div`
  width: calc(100% - calc(var(--universal-pad) * 2));
  margin: 1rem var(--universal-pad) 2rem;
  display: flex;
  flex-direction: column;
  gap: 1rem;
  font-size: 1rem;
  .top {
    display: flex;
    padding: 1rem 1.5rem;
    justify-content: space-between;
    align-items: center;
    border: 1px solid var(--n-grey-0);
    background-color: #036663;
    color: var(--n-grey-0);
    border-radius: var(--border-radius-3);
    .image {
      svg {
        display: block;
      }
    }
    .title {
      font-size: 2rem;
      font-weight: 600;
    }
    .btn {
      flex-grow: 1;
      max-width: 200px;
    }
  }
  .box {
    display: flex;
    gap: 1rem;
    .item {
      padding: 1rem;
      flex-grow: 1;
      background-color: var(--n-grey-0);
      border: 1px solid var(--n-grey-2);
      border-radius: var(--border-radius-3);
      display: flex;
      flex-direction: column;
      gap: 0.5rem;
      .title {
        margin: 1rem 0;
        text-align: center;
        font-size: 1.5rem;
        font-weight: 600;
      }
      .line-v {
        height: 1px;
        background-color: var(--n-grey-1);
      }
      .data {
        margin: 0.5rem 0;
        display: flex;
        flex-direction: column;
        .value {
          padding: 0.7rem 0;
          display: flex;
          gap: 0.5rem;
          border-bottom: 1px solid var(--n-grey-1);
          &:first-child {
            border-top: 1px solid var(--n-grey-1);
          }
        }
      }
      .price {
        margin: 0 0 1rem;
        display: flex;
        align-items: flex-end;
        justify-content: center;
        gap: 0.5rem;
        align-self: center;
        &.main {
          margin: 1rem 0 0;
          position: relative;
          &::after {
            content: "";
            z-index: 1;
            position: absolute;
            top: 50%;
            width: 110%;
            height: 2px;
            border-radius: 10px;
            background-color: red;
          }
        }
        .value {
          font-size: 1.5rem;
          font-weight: 600;
        }
        .curr {
          font-size: 1.2rem;
          font-weight: 600;
        }
      }
    }
  }
  @media screen and (max-width:850px) {
    .top {
      padding: 0 1rem 1rem;
      flex-direction: column;
      gap: 1rem;
      .title {
        font-size: 1.5rem;
        margin-bottom: 1rem;
      }
      .btn {
        align-self: normal;
        max-width: none;
      }
    }
    .box {
      flex-direction: column;
    }
  }
  
`
export default function Pricing34 (props){
  const {data: dataRaw} = props;
  const data = JSON.parse(dataRaw);
  const buy = () => {
    window.alert("no connection to payment system")
  }
  // console.log('aasssdddd')
  // console.log('<<<<<<' + data)
  const makeItems = () => {
    return items.map((v, i) => {
      return (
        <div className='item' key={i}>
          <div className='title'>
            {v.title}
          </div>
          <div className='data'>
            {
              v.values.map((vv, ii) => {
                return (
                  <div className='value' key={ii}>
                    <div className='icon'>
                      <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                        <rect x="6.07129" y="-1" width="10" height="10" rx="3" transform="rotate(45 6.07129 -1)" fill="#036663"/>
                      </svg>
                    </div>
                    <div className='text'>
                      {vv}
                    </div>
                  </div>
                )
              })
            }
          </div>
          <div className='price main'>
            <div className='value'>
              {formatPrice(v.mainPrice)}
            </div>
            <div className='curr'>
              تومان
            </div>
          </div>
          <div className='price'>
            <div className='value'>
              {formatPrice(v.price)}
            </div>
            <div className='curr'>
              تومان
            </div>
          </div>
          <div className='line-v'></div>
          <div className='btn'>
            <TextBtn2
              newType={2}
              text={"خرید اشتراک"}
              onclick={buy}
            />
          </div>
        </div>
      )
    })
    
  }
  return (
    <Styles>
      <div className='top'>
        <div className='image'>
          <svg width="193" height="126" viewBox="0 0 193 126" fill="none" xmlns="http://www.w3.org/2000/svg">
            <mask id="mask0_562_378" style={{maskType: "luminance"}} maskUnits="userSpaceOnUse" x="51" y="17" width="109" height="109">
            <path d="M52.5 18.5H158.5V124.5H52.5V18.5Z" fill="white" stroke="white" strokeWidth="3"/>
            </mask>
            <g mask="url(#mask0_562_378)">
              <mask id="mask1_562_378" style={{maskType: "luminance"}} maskUnits="userSpaceOnUse" x="51" y="17" width="109" height="109">
              <path d="M158.5 124.5V18.5H52.5V124.5H158.5Z" fill="white" stroke="white" strokeWidth="3"/>
              </mask>
              <g mask="url(#mask1_562_378)">
                <path d="M126.504 90.7676H53.1289V31.2517H136.892V80.3789" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M122.687 81.2344H67.335C64.9932 81.2344 63.0771 79.3184 63.0771 76.9766V45.043C63.0771 42.7012 64.9932 40.7852 67.335 40.7852H122.687C125.028 40.7852 126.944 42.7012 126.944 45.043V75.9121" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M146.439 93.2756L157.873 104.71L150.837 111.747L139.402 100.312L133.465 106.25L120.513 74.3863L152.376 87.3383L146.439 93.2756Z" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M105.473 68.9814H98.4971V53.0372H105.473" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M99.5938 61.0098H103.405" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M84.5469 68.9824V53.038H88.5328C90.7252 53.038 92.519 54.8316 92.519 57.0239C92.519 59.2163 90.7252 61.0101 88.5328 61.0101H85.2943" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M88.5332 61.0091L92.5194 68.9814" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M71.5918 68.9814V53.0372H78.5674" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M72.6885 61.0098H76.4999" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M118.428 68.9814H111.452V53.0372H118.428" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
                <path d="M112.549 61.0098H116.36" stroke="white" strokeWidth="3" strokeMiterlimit="22.926" strokeLinecap="round" strokeLinejoin="round"/>
              </g>
            </g>
          </svg>
        </div>
        <div className='title'>
          اشتراک یک ماهه رایگان
        </div>
        <div className='btn'>
          <TextBtn2
            newType={0}
            text={"خرید اشتراک"}
            onclick={buy}
          />
        </div>
      </div>
      <div className='box'>
        {makeItems()}
      </div>
    </Styles>
  )
}


const items = [
  {
    id: 0,
    title: "اشتراک سه ماهه اول",
    values: [
      "دسترسی به بهترین کارگزاران تور",
      "دسترسی به بهترین آژانس‌های مسافرتی",
      "صفحه‌ی وب اختصاصی",
      "مدیریت آسان",
      "ایجاد کیف پول آنلاین",
      "رصد وضعیت مسافران",
      "درج آگهی موثر",
      "خدمات آموزشی ",
    ],
    mainPrice: 30000000,
    price: 10000000
  },
  {
    id: 1,
    title: "اشتراک شش ماهه اول",
    values: [
      "دسترسی به بهترین کارگزاران تور",
      "دسترسی به بهترین آژانس‌های مسافرتی",
      "صفحه‌ی وب اختصاصی",
      "مدیریت آسان",
      "ایجاد کیف پول آنلاین",
      "رصد وضعیت مسافران",
      "درج آگهی موثر",
      "یک آگهی رایگان یک ماهه",
    ],
    mainPrice: 60000000,
    price: 37000000,
  },
  {
    id: 2,
    title: "اشتراک یک ساله اول",
    values: [
      "دسترسی به بهترین کارگزاران تور",
      "دسترسی به بهترین آژانس‌های مسافرتی",
      "صفحه‌ی وب اختصاصی",
      "مدیریت آسان",
      "ایجاد کیف پول آنلاین",
      "رصد وضعیت مسافران",
      "درج آگهی موثر",
      "سه آگهی رایگان یک ماهه",
    ],
    mainPrice: 120000000,
    price: 97000000
  }
]
